export default __webpack_public_path__ + "static/media/congo.9bdf97ba.jpeg";